class NewFeaturedCollections extends HTMLElement {
  constructor() {
    super();
    this.list = this.querySelector('.new-featured-collections__list');
    this.getListLinks = this.querySelectorAll('.new-featured-collections__item');
    this.getButtons = this.querySelectorAll('.new-featured-collections__button');

    this.scrollPath = this.list.clientWidth/2;
    this.getButtons?.forEach(btn => {
      if (this.list.scrollWidth <= this.list.clientWidth) {
        btn.style.display = 'none';
      } else {
        btn.addEventListener('click', () => {
          if (btn.getAttribute('data-switch-action') == 'next') {
            this.list.scrollLeft += this.scrollPath;
          }
          if (btn.getAttribute('data-switch-action') == 'prev') {
            this.list.scrollLeft -= this.scrollPath;
          }
        })
      }

    })
  }

}

customElements.define("new-featured-collections", NewFeaturedCollections);